import { useState } from "react";
import logo from "../../assets/images/logo1.png";
import CustomSvg from "../svgs/CustomSvg";
import { useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi";
import SuccessModal from "./auxiliary/SuccessModal";
import { resetPassword } from "../apiRequests/requestApi";
import { useUser } from "../../utils/hooks";

export default function ResetPassword({ accountType }) {
  const { user } = useUser();
  const navigate = useNavigate();
  const goToLogin = () => navigate("/login");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [successModal, setSuccessModal] = useState({
    visible: false,
    onHide: null,
    size: "md",
  });

  const codeToken = localStorage.getItem("resetPasswordToken");

  const handleSubmit = async () => {
    try {
      await resetPassword({
        email: user?.email,
        token: codeToken,
        newPassword: password,
      });
      setSuccessModal({ visible: true, onHide: handleHideModal, size: "md" });
    } catch (error) {
      // handle error (add error state if needed)
      // console.error(error);
    }
  };

  const handleHideModal = () =>
    setSuccessModal({ visible: false, onHide: null, size: "md" });

  return (
    <div
      className={`min-h-screen flex flex-col  py-20 px-3 ${
        accountType === "celebrity"
          ? "bg-[#222233]"
          : "bg-[#130828]"
      }`}
    >
      {/* Logo and Title */}
      <div className="flex flex-col items-center mb-8">
        <h1
          className={`font-quantico font-bold text-2xl md:text-3xl text-center ${
            accountType === "celebrity"
              ? "bg-gradient-to-r from-[#56920D] to-[#B7D080] bg-clip-text text-transparent"
              : "bg-gradient-to-r from-[#BD3193] to-[#9FCB3A] bg-clip-text text-transparent"
          }`}
        >
          Change <span className="text-inherit">Password</span>
        </h1>
        <p className="text-white/80 text-sm font-poppins mt-2 text-center">
          Enter a new password to gain access to the system
        </p>
      </div>

      {/* Password Fields */}
      <div className="w-full max-w-md flex flex-col gap-5">
        {/* Password */}
        <div
          className={`flex items-center gap-2 px-4 py-3 rounded-xl ${
            accountType === "celebrity"
              ? "bg-white/10 border border-[#B7D080]"
              : "bg-white/10 border border-pink-600"
          }`}
        >
          <CustomSvg name="lock" />
          <input
            type={passwordVisible ? "text" : "password"}
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="Enter your password"
            className="flex-1 bg-transparent border-none outline-none text-white font-quantico text-base"
          />
          <button
            type="button"
            className="focus:outline-none"
            onClick={() => setPasswordVisible(v => !v)}
          >
            {passwordVisible ? (
              <FiEye color="#FFF" size={22} />
            ) : (
              <FiEyeOff color="#FFF" size={22} />
            )}
          </button>
        </div>
        {/* Confirm Password */}
        <div
          className={`flex items-center gap-2 px-4 py-3 rounded-xl ${
            accountType === "celebrity"
              ? "bg-white/10 border border-[#B7D080]"
              : "bg-white/10 border border-pink-600"
          }`}
        >
          <CustomSvg name="lock" />
          <input
            type={confirmPasswordVisible ? "text" : "password"}
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            placeholder="Confirm your password"
            className="flex-1 bg-transparent border-none outline-none text-white font-quantico text-base"
          />
          <button
            type="button"
            className="focus:outline-none"
            onClick={() => setConfirmPasswordVisible(v => !v)}
          >
            {confirmPasswordVisible ? (
              <FiEye color="#FFF" size={22} />
            ) : (
              <FiEyeOff color="#FFF" size={22} />
            )}
          </button>
        </div>
        {/* Submit Button */}
        <button
          onClick={handleSubmit}
          className={`w-full py-3 rounded-xl flex items-center justify-center font-bold text-lg transition ${
            accountType === "celebrity"
              ? "bg-gradient-to-r from-[#56920D] to-[#B7D080] hover:from-[#407a0a] hover:to-[#8fcf2a]"
              : "bg-gradient-to-r from-[#BD3193] to-[#9FCB3A] hover:from-[#a11b7a] hover:to-[#7bbd2a]"
          } text-white`}
        >
          <span className="font-poppins">Continue</span>
          <span className="ml-2 flex items-center">
            <CustomSvg name="arrow-right" />
          </span>
        </button>
      </div>

      {/* Success Modal */}
      <SuccessModal
        modalProps={successModal}
        redirectFunc={goToLogin}
        subTxt="Password changed successfully, we are redirecting you..."
      />
    </div>
  );
}
